module.exports = __webpack_public_path__ + "img/user.13e9f229.jpg";